module.exports = __webpack_public_path__ + "static/media/Beyond_Blue_Girl+Dolphin.099b7896.png";